import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { DebitNote, DebitNoteCreateDTO, DebitNotePage, DebitableLine } from '../interfaces/procurement/debitNote.interface';

export const DebitNoteService = {
  create: async (dto: DebitNoteCreateDTO): Promise<DebitNote> =>
    (await axios.post(ENDPOINTS.DEBIT_NOTE.CREATE, dto)).data,
  listByInstitution: async (page = 0, size = 10): Promise<DebitNotePage> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.DEBIT_NOTE.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  listByBill: async (billId: string): Promise<DebitNote[]> =>
    (await axios.get(ENDPOINTS.DEBIT_NOTE.LIST_BY_BILL(billId))).data,
  debitableLines: async (billId: string): Promise<DebitableLine[]> =>
    (await axios.get(ENDPOINTS.DEBIT_NOTE.DEBITABLE_LINES(billId))).data,
  getById: async (id: string): Promise<DebitNote> =>
    (await axios.get(ENDPOINTS.DEBIT_NOTE.GET_BY_ID(id))).data,
  voidNote: async (id: string, reason: string): Promise<DebitNote> =>
    (await axios.post(ENDPOINTS.DEBIT_NOTE.VOID(id), { reason })).data,
  downloadPdf: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.DEBIT_NOTE.PDF(id), { responseType: 'blob' })).data,
};
